import { FileSubmission, FileStatus } from '@/models/file-submission.tsx'
import Icon from '@/components/shared/Icon.tsx'
import TooltipTrigger from '@/components/shared/TooltipTrigger.tsx'
import { joinClasses } from '@/utils/styling'
import ProgressCircle from '@/components/shared/ProgressCircle.tsx'
import { formatNumber } from '@/utils/numbers'

export default function StatusSectionRejected({ 
    file,
    errorRecordCount
}: { 
    file: FileSubmission,
    errorRecordCount: number
}) {
    const recordCount = file.InputRecords ?? 0,
          errorCount = file.Errors,
          passRecordCount = recordCount ? (recordCount - errorRecordCount) : 0,
          status = FileStatus.get(file.CurrentStatus.toString()),
          statusText = status?.Text ?? '',
          iconColorClass = status?.TextColor ? `text-${status.TextColor}` : '';

    const stats: { 
        label: string; 
        value: number; 
        className?: string; 
    }[] = [
        { label: 'Total errors', value: errorCount, className: 'mb-3' },
        { label: 'Records in submission', value: recordCount },
        { label: 'Records with no errors', value: passRecordCount },
        { label: 'Records with errors', value: errorRecordCount },
    ];

    return (
        <div style={{ height: '22rem' }} className="p-3 border">
            <div className="fs-5 d-flex align-items-center mb-3">
                <Icon name={status?.Icon} className={joinClasses('me-2', iconColorClass)} />
                <span className="me-2 flex-grow-1">Status: <span className="fw-bold">{statusText}</span></span>
                {/* {status?.Text === 'Rejected' && */}
                    <TooltipTrigger tooltipText="Submissions aren't accepted until all records have zero errors. No records were saved to database.">
                        <div><Icon name='info' className="text-muted" /></div>
                    </TooltipTrigger>
                {/* } */}
            </div>
            <div className="mb-4">
                {stats.map(stat => (
                    <div key={stat.label} className={joinClasses("d-flex align-items-center justify-content-between", stat.className)}>
                        <span className="d-inline-block" style={{ width: '11em' }}>{ stat.label }: </span>
                        <span className="d-inline-block text-end fw-bold" style={{ width: '4em' }}>{ formatNumber(stat.value) }</span>
                    </div>
                ))}
            </div>
            {/* <div className="mb-3"><span className="fw-bold">{recordCount} records</span> in submission</div>
            <div className="mb-3"><span className="fw-bold">{errorCount} errors</span></div> */}
            <div className="mx-auto" style={{maxWidth: '8rem'}}>
                <ProgressCircle
                    value={passRecordCount}
                    total={recordCount}
                    fontSize={2}
                    smallText="pass"
                    remainingColor="#dc3545" // Bootstrap danger red
                />
            </div>
        </div>
    )
}